export const twoFloatingPointFormat = function (t) {
	if (typeof t !== "string") t = String(t);
	return t.indexOf(".") >= 0
		? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
		: t;
};

export const currencyRules = {
	min: {
		value: 0,
		message: "The minimum value is 0",
	},
	max: {
		value: 1000000000000,
		message: "This field can not be more than 1 trillion",
	},
};

export const hardLimitCurrency = (amount) =>
	amount > 1000000000000 ? 1000000000000 : amount;

export const formatCurrency = (str) =>
	Number(parseFloat(twoFloatingPointFormat(str)));

export const currencyStyle = (str, floatingPoint = 0) => {
	let tmpStr = str;
	if (typeof str !== 'number' && !isNaN(parseFloat(str))) {
		tmpStr = parseFloat(str)
		str = Number(tmpStr.toFixed(2))
	} else if (typeof str === 'number') {
		str = Number(str.toFixed(2))
	}

	if (floatingPoint)
		str = str.toFixed(floatingPoint)

	let res = String(str).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').replaceAll("-", "")

	if (tmpStr < 0)
		return `(${res})`

	return res;
}

export const parseCurrency = (str) => {
	str = String(str)
	const isMinus = str.indexOf("(") !== -1 || str.indexOf("-") !== -1
	let res = parseFloat(str.replaceAll("-", "").replaceAll(",", "").replaceAll("$ ", "").replaceAll("(", "").replaceAll(")", ""))

	if (isMinus)
		return -res

	return res;
}
